import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { getRoutes } from './routes.js';
import './styles/app.scss';

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path={routes.browse.path}
          element={<routes.browse.component customer={instance.customer} />}
        />
        <Route
          path={routes.search.path}
          element={<routes.search.component customer={instance.customer} />}
        />
        <Route
          path={routes.product.path}
          element={<routes.product.component customer={instance.customer} />}
        />
        <Route path={routes.home.path} element={<routes.home.component />} />
        <Route path={routes.generic.path} element={<routes.generic.component />} />
      </Routes>
    </>
  );
};
